// generate string of format yyyyMMddTttttttZ from a date object
export const icsDateTimeString = function (date) {
    if (date instanceof Date === false)  {
        throw new Error('Error: Can only convert Dates to icsDateTimeStrings!');
    }

    return date.toISOString().replaceAll('-', '').replaceAll(':', '').substr(0, 15) + 'Z';
};


// generates the text for a basic ics file based on some properties
export const generateIcsFile = function (title, description, location, start, end) {
    let now = new Date();

    return [
        "BEGIN:VCALENDAR",

        // general info
        "VERSION:2.0",
        "PRODID:https://www.digital-x.eu/de/events/",
        "METHOD:PUBLISH",
        "BEGIN:VTIMEZONE",

        // hardcode the timezone to Europe/Berlin for now
        "TZID:Europe/Berlin",
        "BEGIN:STANDARD",
        "DTSTART:16011028T030000",
        "RRULE:FREQ=YEARLY;BYDAY=-1SU;BYMONTH=10",
        "TZOFFSETFROM:+0200",
        "TZOFFSETTO:+0100",
        "END:STANDARD",
        "BEGIN:DAYLIGHT",
        "DTSTART:16010325T020000",
        "RRULE:FREQ=YEARLY;BYDAY=-1SU;BYMONTH=3",
        "TZOFFSETFROM:+0100",
        "TZOFFSETTO:+0200",
        "END:DAYLIGHT",
        "END:VTIMEZONE",

        // event info
        "BEGIN:VEVENT",
        "UID:" + now.getTime() + "@digital-x.eu",
        "SUMMARY:" + title,
        "LOCATION:" + location,
        "DESCRIPTION:" + description,
        "DTSTART;TZID=Europe/Berlin:" + icsDateTimeString(start),
        "DTEND;TZID=Europe/Berlin:" + icsDateTimeString(end),
        "DTSTAMP:" + icsDateTimeString(now),
        "END:VEVENT",

        "END:VCALENDAR"
    ].join('\r\n');
};


// triggers the download of an ics file by inserting a link into the DOM and clicking on it
export const triggerDownload = function (fileName, fileContent) {
    try {
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/calendar;base64,' + btoa(fileContent));
        element.setAttribute('download', fileName);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    } catch (e) {
        console.log(e);
    }
};



// WEBPACK FOOTER //
// ./src/ics.js